import React, { useEffect, useState } from "react";
import classes from "../Widget/Widget.module.scss";
import { CiSearch } from "react-icons/ci";
import { RxCross2 } from "react-icons/rx";
import { AnimatePresence, motion } from "framer-motion";

const Search = (props) => {
  const { currentStep, finished, handleOnSearch, searchText, setSearchText } =
    props;
  const [searchVisible, setSearchVisible] = useState(false);

  useEffect(() => {
    const input = document.getElementById("searchText");
    if (input) {
      input.focus();
    }
  }, [searchVisible]);

  const handleSearch = (event) => {
    const searchText = event.target.value;
    setSearchText(searchText);
    handleOnSearch(searchText);
  };

  const handleExit = () => {
    setSearchText("");
    handleOnSearch("");
  };

  return (
    <>
      {currentStep === 1 && !finished && (
        <div
          style={{
            flex: "flex",
            direction: "row",
            width: "100%",
          }}
        >
          {searchVisible && (
            <AnimatePresence>
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
              >
                <div
                  className={classes["search-container-focus"]}
                  isfocused={searchVisible ? "yes" : "no"}
                >
                  <div className={classes["main-search-text-icon-focus"]}>
                    <CiSearch
                      className={classes["search-text-icon-focus"]}
                      size="20"
                    />
                  </div>
                  <input
                    type="text"
                    id="searchText"
                    name="searchText"
                    onChange={handleSearch}
                    className={classes["search-text-input-focus"]}
                    value={searchText}
                    autofocus
                    onFocus={() => {
                      setSearchVisible(true);
                    }}
                  />
                  <RxCross2
                    className={classes["cross-text-icon-focus"]}
                    onClick={() => {
                      setSearchVisible(false);
                      handleExit();
                    }}
                    size="20"
                    style={{ cursor: "pointer" }}
                  />
                </div>
              </motion.div>
            </AnimatePresence>
          )}

          {!searchVisible && (
            <AnimatePresence>
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
              >
                <div className={classes["search-container"]}>
                  <CiSearch
                    className={classes["search-text-icon"]}
                    size="20"
                    strokeWidth={1}
                    onClick={() => setSearchVisible(true)}
                  />
                  <input
                    type="text"
                    name="searchText"
                    onChange={handleSearch}
                    className={classes["search-text-input"]}
                    placeholder="RICERCA"
                    value={searchText}
                    onBlur={() => {
                      setSearchVisible(false);
                    }}
                    onFocus={() => {
                      setSearchVisible(true);
                    }}
                  />
                </div>
              </motion.div>
            </AnimatePresence>
          )}
        </div>
      )}
    </>
  );
};

export default Search;
